import React from 'react';
import { useTranslation } from 'react-i18next';
import FlatGlassStructureUtils from 'components/ThreeJs/assets/filter/Glass/FlatGlassStructureUtils';
import { formatNumberToFixed } from 'utils';
import GlassConfigDetailItem from '../GlassConfigDetailItem';

const GlassConfigDetailSecond = ({ configDetails, showPrice, priceVolumeCat }) => {
	const { t } = useTranslation('commonConfigurationAction');
	const { sqmPrice } = configDetails.flatGlassStructure;
	const volDiscountSqmPrice = FlatGlassStructureUtils.getSqmPrice(
		configDetails.flatGlassStructure,
		priceVolumeCat
	);
	const hasPrice = sqmPrice !== null;
	const price = showPrice && (
		<span className="glass_config_block__price_discounted">
			{formatNumberToFixed(volDiscountSqmPrice || t('priceOnDemand'), 2, t('i18n:numberFormat'))}
		</span>
	);
	return (
		<ul className="glass_config__details glass_config__details--indent_state">
			<GlassConfigDetailItem
				categoryLabel="fireResistanceClass"
				selected={configDetails.fireResistanceClass}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="manufacturer"
				selected={configDetails.manufacturer}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="whiteGlass"
				selected={configDetails.whiteGlass}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="application"
				selected={configDetails.application}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="structure"
				selected={configDetails.structure}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="insulation"
				selected={configDetails.insulation}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="sound"
				selected={configDetails.sound}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="resistanceClass"
				selected={configDetails.resistanceClass}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="buttJoints"
				selected={configDetails.buttJoints}
				secondLayoutOption
			/>
			<GlassConfigDetailItem
				categoryLabel="sqmWeight"
				selected={formatNumberToFixed(
					configDetails.flatGlassStructure.sqmWeight,
					0,
					t('i18n:numberFormat')
				)}
				secondLayoutOption
			/>
			{showPrice && (
				<GlassConfigDetailItem
					categoryLabel="sqmPrice"
					selected={
						!hasPrice || priceVolumeCat === '0' || sqmPrice <= volDiscountSqmPrice ? (
							price
						) : (
							<>
								<span className="glass_config_block__price_full">
									{formatNumberToFixed(sqmPrice || t('priceOnDemand'), 2, t('i18n:numberFormat'))}
								</span>
								{price}
							</>
						)
					}
					secondLayoutOption
				/>
			)}
		</ul>
	);
};

export default GlassConfigDetailSecond;
